export default __webpack_public_path__ + "static/wc-product-detailed-batch-code-image-8fc829b910027a536076985273cb8ec5.png";